import { render, staticRenderFns } from "./SupportAI.vue?vue&type=template&id=0a5c6e9d&scoped=true&"
import script from "./SupportAI.vue?vue&type=script&lang=js&"
export * from "./SupportAI.vue?vue&type=script&lang=js&"
import style0 from "./SupportAI.vue?vue&type=style&index=0&id=0a5c6e9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c6e9d",
  null
  
)

export default component.exports